import Vue from 'vue';
import App from './App';
import { router } from './router';
import ElementUI from 'element-ui';
//样式文件需要单独引入
import 'element-ui/lib/theme-chalk/index.css';

// require('./mock.js')
Vue.use(ElementUI);
new Vue({
  router,
  el: '#app',
  render: h => h(App)
});
